import { render } from "./CareersPage.vue?vue&type=template&id=136c3a00"
import script from "./CareersPage.vue?vue&type=script&lang=js"
export * from "./CareersPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__